import app from 'flarum/forum/app';
import {extend} from 'flarum/common/extend';
import SettingsPage from 'flarum/forum/components/SettingsPage';

export default function () {
    extend(SettingsPage.prototype, 'accountItems', function (items) {
        if (this.user!.attribute('kilowhatWordpressIsLinked')) {
            items.remove('changeEmail');
            items.remove('changePassword');

            items.add('kilowhat-wordpress', m('a.Button', {
                href: app.forum.attribute('kilowhatWordpressProfileLink'),
            }, app.translator.trans('kilowhat-wordpress.forum.settings.edit_on_wordpress')));
        }
    });
}
